module.exports = __webpack_public_path__ + "static/media/sas.b5d917b0.jpg";